export const camelToSentenceCase = (str: string) => {
  const result = str
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .toLowerCase();

  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const sentenceCase = (str: string) => {
  str = str.replace(/_/g, ' ');
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalCase = (str: string) => {
  return str
    .split(' ')
    .map(word => capitalize(word))
    .join(' ');
};

/** wraps a string at a given character count, breaking on spaces */
export const wrapText = (text: string, lineLength: number) =>
  text
    .split(' ')
    .reduce<string[]>((acc, word) => {
      if (acc[acc.length - 1]?.length < lineLength) {
        acc[acc.length - 1] += ` ${word}`;
      } else {
        acc.push(word);
      }
      return acc;
    }, [])
    .join('\n');
